// extracted by mini-css-extract-plugin
export var booksCardWrapper = "books-module--booksCardWrapper--1njQe";